const { documentReady, windowLoaded } = require('@grpn/document-states');
const { removeDuplicateCookies } = require('src/frontend/core/cookie-monster');
const { setUserLocaleCookie } = require('src/frontend/core/user_locale');
require('src/frontend/vendor/md5');

require('src/frontend/core/grouponDesktopObject-v7');
const I18n = require('node_modules/grapefruit/lib/I18n');

import trackGoogleTranslate from 'src/frontend/core/track-g-translate';

trackGoogleTranslate();
const dataSet = document.head.dataset;
const options = {
  country: dataSet.country,
  locale: dataSet.locale,
  lang: dataSet.lang,
  brandId: dataSet.brand,
};
window.I18n = new I18n(options);

setUserLocaleCookie(window.I18n);
require('src/frontend/lazyload/lazyLoadImages');

documentReady.then(() => {
  Groupon.Utils.lazyLoadImages();
});

windowLoaded.then(() => {
  removeDuplicateCookies();
});
